import { Loan, LoanStatus } from '../types/loan.types';
import { FilterType } from '../components/common/Header';

export const filterLoans = (
  loans: Loan[],
  filter: FilterType,
  search: string,
  statusFilter: LoanStatus | 'all'
): Loan[] => {
  let filtered = loans;

  // Filter by dashboard card filter
  if (filter !== 'all') {
    const today = new Date();
    const midnight = new Date(today);
    midnight.setHours(0, 0, 0, 0);

    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay());
    startOfWeek.setHours(0, 0, 0, 0);

    switch (filter) {
      case 'created_today':
        filtered = filtered.filter(loan => {
          const loanDate = new Date(loan.createdAt);
          loanDate.setHours(0, 0, 0, 0);
          return loanDate.getTime() === midnight.getTime();
        });
        break;
      case 'pending_customer_docs':
        filtered = filtered.filter(loan => {
          const updatedAt = new Date(loan.updatedAt);
          const isUpdatedSinceMidnight = updatedAt >= midnight;
          const hasCorrectStatus =
            loan.status === 'CONDITIONAL_OFFER_RECEIVED' ||
            loan.status === 'CONDITIONAL_OFFER_REFERRED' ||
            loan.status === 'PENDING_CUSTOMER_DOCUMENTS';
          return isUpdatedSinceMidnight && hasCorrectStatus;
        });
        break;
      case 'pending_signed_docs':
        filtered = filtered.filter(loan => loan.status === 'PENDING_SIGNED_DOCUMENTS');
        break;
      case 'pending_fulfilment':
        filtered = filtered.filter(loan => loan.status === 'PENDING_FULFILMENT');
        break;
      case 'equity_uploaded_week':
        filtered = filtered.filter(loan => {
          const loanDate = new Date(loan.createdAt);
          return loanDate >= startOfWeek;
        });
        break;
      default:
        break;
    }
  }

  // Search filter
  if (search.trim() !== '') {
    const s = search.trim().toLowerCase();
    filtered = filtered.filter(
      loan =>
        loan.id.toLowerCase().includes(s) ||
        loan.clientFirstName.toLowerCase().includes(s) ||
        loan.clientLastName.toLowerCase().includes(s)
    );
  }

  // Status filter
  if (statusFilter !== 'all') {
    filtered = filtered.filter(loan => loan.status === statusFilter);
  }

  // Always sort by updatedAt descending
  filtered = filtered.sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );

  return filtered;
};

export const getFilterLabel = (filter: FilterType): string => {
  switch (filter) {
    case 'all':
      return 'All Loans';
    case 'created_today':
      return 'Created Today';
    case 'pending_customer_docs':
      return 'Pending Customer Documents (Updated Today)';
    case 'pending_signed_docs':
      return 'Pending Signed Documents';
    case 'pending_fulfilment':
      return 'Pending Fulfilment';
    case 'equity_uploaded_week':
      return 'Equity Uploaded This Week';
    default:
      return 'All Loans';
  }
};